module.exports = __webpack_public_path__ + "img/amex-v2.svg";